export default __webpack_public_path__ + "static/media/bruno.e311b5f5.png";